import { useTenantSettings } from "@/modules/settings/queries/useTenantSettings";
import { usePublicTenantSettings } from "@/modules/settings/queries/usePublicTenantSettings";

export const setupTenantSettings = () => {
  useTenantSettings();

  usePublicTenantSettings();
};
